export enum SelectType {
  REGULAR,
  DARKSMALL,
  DARKMEDIUM
}

export default SelectType;